import get from 'lodash/get';
import map from 'lodash/map';

import countries from '../Country/country.list.json';

export const hasRegions = (countryCode: string) => !!get(countries, `${countryCode}.regions`);

export const getRegionList = (
  countryCode: string
): {
  regionCode: string;
  regionName: string;
}[] =>
  map(
    get(countries, `${countryCode.toUpperCase()}.regions`),
    ({ code, name }: { code: string; name: string }) => ({
      regionCode: code,
      regionName: name,
    })
  );

export const normalizeRegion = (regionName: string) =>
  regionName
    .replace(/[.\s]/g, '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const getRegionFromRegionName = ({
  countryCode,
  regionName,
}: {
  countryCode: string;
  regionName: string;
}) => {
  let region = { regionCode: '', regionName: '' };

  if (
    countryCode &&
    typeof countryCode === 'string' &&
    regionName &&
    typeof regionName === 'string'
  ) {
    const regions = getRegionList(countryCode);
    const normalizedRegion = normalizeRegion(regionName);

    // eslint-disable-next-line no-shadow
    regions.find(({ regionCode, regionName }) => {
      if (
        normalizedRegion === normalizeRegion(regionName) ||
        normalizedRegion === normalizeRegion(regionCode)
      ) {
        // eslint-disable-next-line no-return-assign
        return (region = { regionCode, regionName });
      }
      return false;
    });
  }
  return region;
};

export const getRegionCodeFromRegionName = ({
  countryCode,
  regionName,
}: {
  countryCode: string;
  regionName: string;
}) => get(getRegionFromRegionName({ countryCode, regionName }), 'regionCode', '');
